module.exports = __webpack_public_path__ + "static/read-people-like-a-book-b90cdcff6c4a4a6dde4f7e2372f220ed.webp";